import Class from './c-content-meters';
import './c-content-meters@.vue';

export default Class;